export default "__VITE_ASSET__BiQ4fsF___"